import { render, staticRenderFns } from "./OutStockTransferBackScanConfirm.vue?vue&type=template&id=5373d20c&"
import script from "./OutStockTransferBackScanConfirm.vue?vue&type=script&lang=js&"
export * from "./OutStockTransferBackScanConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports